import {ArenaHeaderButtonLabelCasino888MiniOrbitBox} from "./arena-header-button-label.casino888.mini-orbit.box";

export const ArenaHeaderButtonLabelCasino888CisBox = ArenaHeaderButtonLabelCasino888MiniOrbitBox;